import React from 'react';
import { EazyworksKlantenQueryProvider } from './eazyworks-klanten-list.page';

export const EazyworksProviders = ({ children }: any) => {
	return <EazyworksKlantenQueryProvider>{children}</EazyworksKlantenQueryProvider>;
};
